import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-social-facebook-1',
  standalone: true,
  templateUrl: '../../assets/social/facebook-1.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamSocialFacebook1Icon {}
